import { FC } from "react";
import Affiliate from "../models/affiliate";
import { Button, Card, CardActions, CardContent, CardMedia, Stack, Typography } from "@mui/material";
import { getPublicAffiliateImageUrl } from "../utils/fileUtils";

type Props = {
	affiliate: Affiliate;
};

const AffiliateTile: FC<Props> = ({ affiliate }) => {
	return (
		<Card sx={{ width: 350 }}>
			<CardMedia
				sx={{
					height: 120
				}}
				image={getPublicAffiliateImageUrl(affiliate)}
				title={affiliate.name}
			/>
			<CardContent>
				<Stack spacing={2}>
					<Typography variant="h5" color="textPrimary">{affiliate.name}</Typography>
					<Typography variant="body1" color="textSecondary">{affiliate.description}</Typography>
				</Stack>
			</CardContent>
			<CardActions>
				<Button size="small" fullWidth href={affiliate.url} target="_blank">Check it out!</Button>
			</CardActions>
		</Card>
	)
};

export default AffiliateTile;